import gql from 'graphql-tag'
import createMutation from 'legacy/apollo/createMutation'

const mutation = gql`
  mutation (
    $recurringShiftId: ID!
    $localStartsAtHour: Int!
    $localEndsAtHour: Int!
    $shiftStartSecondsSinceMidnight: Int!
    $shiftLengthSeconds: Int!
  ) {
    recurringShiftUpdate(
      recurringShiftId: $recurringShiftId
      localStartsAtHour: $localStartsAtHour
      localEndsAtHour: $localEndsAtHour
      shiftStartSecondsSinceMidnight: $shiftStartSecondsSinceMidnight
      shiftLengthSeconds: $shiftLengthSeconds
    ) {
      recurringShift {
        id
        localStartsAtHour
        localEndsAtHour
        excludeDates
        shiftType
      }
    }
  }
`

interface Data {
  recurringShiftUpdate: {
    recurringShift: {
      id: string
      localStartsAtHour: number
      localEndsAtHour: number
      excludeDates?: string[]
      shiftType: string
    }
  }
}

interface Variables {
  recurringShiftId: string
  localStartsAtHour: number
  localEndsAtHour: number
  shiftStartSecondsSinceMidnight: number
  shiftLengthSeconds: number
}

export default createMutation<Data, Variables>(mutation)
